<template>
  <validation-observer ref="simpleRules">
    <b-form class="mt-1">

      <b-row>
        <!-- Action Plan -->
        <b-col>
          <b-form-group
            :label="$t('Action Taken')"
            label-for="mc-action-taken"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Action Taken')"
              rules="required"
            >
              <v-select
                id="vue-select-action-taken"
                v-model="item.actionTaken"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionActionTaken || []"
                :placeholder="$t('Select...')"
                :clearable="false"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- Categories -->
        <b-col>
          <b-form-group
            :label="$t('Categories')"
            label-for="mc-categories"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Categories')"
              rules="required"
            >
              <v-select
                id="vue-select-categories"
                v-model="categories"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionCategories || []"
                :placeholder="$t('Select...')"
                :clearable="false"
                :state="errors.length > 0 ? false : null"
                multiple
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- CategoriesDescription -->
      <b-row>
        <b-col>
          <!-- CategoriesDescription -->
          <b-form-group
            :label="$t('Categories Description')"
            label-for="mc-taken-description"
          >
            <b-form-textarea
              v-model="item.categoriesDescription"
              :placeholder="$t('Description...')"
            />

          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <!-- Description -->
          <b-form-group
            :label="$t('Action Taken Description')"
            label-for="mc-taken-description"
          >
            <b-form-textarea
              v-model="item.actionTakenDescription"
              :placeholder="$t('Description...')"
            />

          </b-form-group>
        </b-col>
      </b-row>

      <b-button
        variant="success"
        :disabled="inProgress"
        @click="validationForm"
      >
        <span v-if="!inProgress">{{ $t('Close') }}</span>
        <span v-else>{{ $t('Please wait...') }}</span>
      </b-button>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BForm, BRow, BCol, BFormTextarea, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    hotAlert: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inProgress: false,
      defaultItem: {
        actionTaken: null,
        actionTakenDescription: null,
      },
      categories: [],
      categoriesDescription: null,
      required,
      optionUser: [],
      optionActionTaken: [],
      optionCategories: [],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  watch: {
    item() {
      this.handleCategories()
    },
  },
  async created() {
    this.getUserOptions()
    this.getCategoryOptions()
    this.getTakenActionOptions()
    this.handleCategories()
  },
  methods: {
    handleCategories() {
      if (this.hotAlert && this.hotAlert.categories && this.hotAlert.categories.length && !this.categories.length) {
        this.hotAlert.categories.forEach(c => {
          this.categories.push(c)
        })
      }
      // if (this.hotAlert && this.hotAlert.contactstatus && !this.contactStatus) {
      //   this.contactStatus = this.hotAlert.contactstatus
      // }
    },
    getUserOptions() {
      useJwt.axiosIns.get('user/short').then(response => {
        this.optionUser = response.data
      })
    },
    getTakenActionOptions() {
      useJwt.axiosIns.get(`hotalert/${this.item.projectId}/TakenActionPlanOptions`).then(response => {
        this.optionActionTaken = response.data
      })
    },
    getCategoryOptions() {
      useJwt.axiosIns.get(`hotalert/${this.item.projectId}/Categories`).then(response => {
        if (response.data) {
          this.optionCategories = response.data
        }
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.inProgress = true
          const postItem = JSON.parse(JSON.stringify(this.item))
          useJwt.axiosIns.patch('hotAlert/assigments', postItem)
            .then(response => {
              if (response.data) {
                // Close main hot alert object
                const postItem2 = {
                  projectId: postItem.projectId, orjRef: postItem.orjRef, categoriesDescription: postItem.categoriesDescription,
                }
                if (this.categories.length) {
                  postItem2.categories = this.categories.join('|')
                }

                useJwt.axiosIns.patch('hotAlert/close', postItem2)
                  .then(response2 => {
                    if (response2.data) {
                      // this.$emit('submit', postItem.id)
                      this.$emit('refreshHotAlert')
                      this.$refs.simpleRules.reset()
                      this.inProgress = false
                    }
                  })
                  .catch(e => {
                    this.inProgress = false
                    console.log(e)
                  })
              }
            })
            .catch(e => {
              this.inProgress = false
              console.log(e)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
